import './N8nConfirmationCard.css';
import { useState, useContext } from 'react';
import { AuthContext } from '../../authContext';

function InputTable({ inputs }) {
    const entries = Object.entries(inputs || {});
    if (entries.length === 0) return <p className="n8n-confirm-no-inputs">Sem parâmetros adicionais.</p>;
    return (
        <table className="n8n-confirm-inputs-table">
            <tbody>
                {entries.map(([key, val]) => (
                    <tr key={key}>
                        <td className="n8n-confirm-input-key">{key}</td>
                        <td className="n8n-confirm-input-val">{String(val)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

function ResultDisplay({ result, toolName }) {
    const { tool_output, latency_ms } = result;
    const renderOutput = () => {
        if (!tool_output) return null;
        const isRaw = typeof tool_output === 'object' && Object.keys(tool_output).length === 1 && 'raw' in tool_output;
        if (isRaw) return <pre className="n8n-confirm-result-raw">{tool_output.raw}</pre>;
        if (typeof tool_output === 'string') return <p className="n8n-confirm-result-text">{tool_output}</p>;
        const displayText = tool_output.message || tool_output.output || tool_output.result || tool_output.text;
        if (displayText) return <p className="n8n-confirm-result-text">{String(displayText)}</p>;
        return <pre className="n8n-confirm-result-json">{JSON.stringify(tool_output, null, 2)}</pre>;
    };
    return (
        <div className="n8n-confirm-result">
            <span className="n8n-confirm-result-title">✓ {toolName}{latency_ms != null && <> · {latency_ms}ms</>}</span>
            {renderOutput()}
        </div>
    );
}

export default function N8nConfirmationCard({ pending }) {
    const { accessToken } = useContext(AuthContext);
    const [state, setState] = useState('idle'); // idle | running | done | cancelled
    const [results, setResults] = useState([]);

    const { calls = [], assistant_id, session_id, user_email } = pending || {};

    const handleConfirm = async () => {
        setState('running');
        const outcomes = await Promise.all(
            calls.map(async (call) => {
                try {
                    const resp = await fetch(`${process.env.REACT_APP_API_URL}/post_execute_n8n_tool`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        },
                        body: JSON.stringify({
                            assistant_id,
                            tool_id: call.tool_id,
                            inputs: call.inputs || {},
                            message: '',
                            session_id,
                            user_email,
                            history: [],
                            triggered_by: 'confirmation_ui'
                        })
                    });
                    const data = await resp.json();
                    return { call, data, ok: !!data.status };
                } catch {
                    return { call, data: null, ok: false };
                }
            })
        );
        setResults(outcomes);
        setState('done');
    };

    const handleCancel = () => setState('cancelled');

    if (state === 'cancelled') {
        return (
            <div className="n8n-confirm-card n8n-confirm-card--cancelled">
                <span className="n8n-confirm-cancelled-label">✗ Execução cancelada.</span>
            </div>
        );
    }

    if (state === 'done') {
        return (
            <div className="n8n-confirm-card n8n-confirm-card--done">
                {results.map(({ call, data, ok }, i) => (
                    ok
                        ? <ResultDisplay key={i} result={data} toolName={call.tool_name} />
                        : (
                            <div key={i} className="n8n-confirm-error">
                                <span className="n8n-confirm-error-icon">✗</span>
                                <span>{call.tool_name}: erro ao executar.</span>
                            </div>
                        )
                ))}
            </div>
        );
    }

    return (
        <div className="n8n-confirm-card">
            <div className="n8n-confirm-header">
                <span className="n8n-confirm-icon">⚙</span>
                <span className="n8n-confirm-title">
                    {calls.length === 1
                        ? `Executar "${calls[0].tool_name}"?`
                        : `Executar ${calls.length} ferramentas?`}
                </span>
            </div>

            <div className="n8n-confirm-calls">
                {calls.map((call, i) => (
                    <div key={i} className="n8n-confirm-call">
                        <span className="n8n-confirm-call-name">{call.tool_name}</span>
                        <InputTable inputs={call.inputs} />
                    </div>
                ))}
            </div>

            {state === 'running' ? (
                <div className="n8n-confirm-running">
                    <span className="n8n-confirm-spinner" />
                    <span>A executar...</span>
                </div>
            ) : (
                <div className="n8n-confirm-actions">
                    <button type="button" className="n8n-confirm-btn n8n-confirm-btn-cancel" onClick={handleCancel}>
                        Cancelar
                    </button>
                    <button type="button" className="n8n-confirm-btn n8n-confirm-btn-confirm" onClick={handleConfirm}>
                        Confirmar
                    </button>
                </div>
            )}
        </div>
    );
}
